import script from "./RankingItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingItemList.vue?vue&type=script&setup=true&lang=js"

import "./RankingItemList.vue?vue&type=style&index=0&id=403e6233&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403e6233"]])

export default __exports__